import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Field } from 'formik';
import { appTheme } from '../../../theme';

const Units = styled.div`
  margin-left: ${appTheme.spacing.small};
`;

const Container = styled.div`
  align-items: baseline;
  display: flex;

  * {
    flex: 1;
  }
`;

function FieldWithUnits({ component, type, units, ...rest }) {
  return (
    <Container>
      <Field {...rest} component={component} type={type} />
      <Units>{units}</Units>
    </Container>
  );
}

FieldWithUnits.propTypes = {
  component: PropTypes.func.isRequired,
  units: PropTypes.string.isRequired,

  type: PropTypes.string,
};

FieldWithUnits.defaultProps = {
  type: 'number',
};

export default FieldWithUnits;



// WEBPACK FOOTER //
// ./src/modules/common/form/FieldWithUnits.js